import { render } from "./MainGameRules.vue?vue&type=template&id=414a0586"
import script from "./MainGameRules.vue?vue&type=script&lang=js"
export * from "./MainGameRules.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__